import { ChangeDetectorRef, Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { User } from '../../../models/user';
import { MatSnackBar } from '@angular/material/snack-bar';

import { UserService } from '../../../services/user.service';
import { ConversationService } from '../../../services/conversation.service';
import { NetworkService } from '../../../services/network';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'new-conversation-dialog',
  imports: [MatIconModule, MatInputModule, MatButtonModule, FormsModule],
  templateUrl: './new-conversation-dialog.html',
  styleUrls: ['./new-conversation-dialog.css'],
})
export class NewConversationDialogComponent implements OnInit {
  users: any[] = [];
  filteredUsers: any[] = [];
  searchQuery = '';
  selectedUsers: any[] = [];
  groupName = '';
  currentUserId!: number;

  constructor(
    private userService: UserService,
    private networkService: NetworkService,
    private cdr: ChangeDetectorRef,
    private conversationService: ConversationService,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<NewConversationDialogComponent>,

    @Inject(MAT_DIALOG_DATA)
    public data: {
      currentUserId: number;
      mode?: 'new-conversation' | 'add-members';
      existingMemberIds?: number[];
    },
  ) {}

  ngOnInit(): void {
    this.currentUserId = this.userService.currentUser?.id ?? 0;
    const existingMemberIds = this.data?.existingMemberIds ?? [];

    this.networkService.getConnections(this.currentUserId).subscribe({
      next: (connections) => {
        const connectedUsers = connections.map((conn) =>
          conn.requester_id === this.currentUserId ? conn.addressee : conn.requester,
        );

        this.users = connectedUsers.filter((user) => !existingMemberIds.includes(user.id));
        this.filteredUsers = [...this.users];
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('Failed to load connections:', err);
      },
    });
  }

  filterUsers(): void {
    const q = this.searchQuery.trim().toLowerCase();
    if (!q) {
      this.filteredUsers = [...this.users];
      return;
    }
    this.filteredUsers = this.users.filter((user) =>
      `${user.preferredName || user.first_name} ${user.last_name}`.toLowerCase().includes(q),
    );
  }

  selectUser(user: any): void {
    this.dialogRef.close(user);
  }

  toggleUser(user: User): void {


    const exists = this.selectedUsers.some((u) => Number(u.id) === Number(user.id));



    if (exists) {
      this.selectedUsers = this.selectedUsers.filter((u) => Number(u.id) !== Number(user.id));
    } else {
      this.selectedUsers.push(user);
    }

  }

  isSelected(user: any) {
    return this.selectedUsers.some((u) => u.id === user.id);
  }

  isAddMembersMode(): boolean {
    return this.data?.mode === 'add-members';
  }

  addMembers(): void {
    const selectedUserIds = this.selectedUsers.map(user => user.id);

    this.dialogRef.close({
      selectedUserIds
    });
  }


  createConversation(): void {
    if (this.selectedUsers.length === 0) {
      return;
    }

    if (this.selectedUsers.length === 1) {
      const otherUser = this.selectedUsers[0];

      this.conversationService
        .createDirectConversation(this.currentUserId, otherUser.id)
        .subscribe((response) => {
          this.dialogRef.close(response);
        });
      return;
    }


    const memberIds = this.selectedUsers.map((user) => user.id);

    this.conversationService
      .createGroupConversation(this.currentUserId, memberIds, this.groupName || 'Group Chat')
      .subscribe({
        next: (response) => {
          this.dialogRef.close(response);
        },
        error: (err) => {
          const message = err?.error?.error || 'Failed to create group chat.';
          this.snackBar.open(message, 'Dismiss', { duration: 5000 });
        },
      });
  }
}
